import {Injectable} from '@angular/core';
import {RequesterService} from '../../../services/requester.service';
import {
    SkillsCheckerListItemModel,
    SkillsCheckerModel
} from '../model/skills-checker.model';
import {DevelopmentReportDtoModel} from '../model/development-report-dto.model';
import {SkillsCheckerFormModel, SkillsCheckerFormRequestModel, SkillsCheckerFormResponseModel} from '../model/skills-checker-form.model';
import {EventsService} from '../../../services/events.service';

@Injectable({
    providedIn: 'root'
})
export class SkillsCheckerService {

    public mySkillCheckerList: SkillsCheckerModel[] = null;

    constructor(
        private event: EventsService,
        private requesterService: RequesterService
    ) {
    }

    getMySkillsCheckerList(): Promise<Array<SkillsCheckerModel>> {
        return this.requesterService.get('getMySkillsCheckerList')
            .then(data => {
                if (!!data.result && Array.isArray(data.result) && data.result.length > 0) {
                    this.mySkillCheckerList = data.result;
                    return this.mySkillCheckerList;
                } else {
                    return [];
                }
            })
            .catch(e => {
                console.error('Error in: getMySkillsCheckerList', e);
                return [];
            });
    }

    getDevelopmentReport(scId: number, delId: number = null): Promise<DevelopmentReportDtoModel> {
        let method = 'getMyDevelopmentReport';
        let params: any = {sc_id: scId};
        if (delId !== null) {
            method = 'getUserDevelopmentReport';
            params = {...params, del_id: delId};
        }
        return this.requesterService.get(method, params)
            .then(data => {
                if (!!data.result) {
                    return data.result;
                } else {
                    return null;
                }
            })
            .catch(e => {
                console.error('Error in: getMySkillsCheckerList', e);
                return null;
            });
    }

    getSkillsCheckersList(managerId = 0): Promise<Array<SkillsCheckerListItemModel>> {
        const params: any = {manager_id: managerId};
        return this.requesterService.get('getSkillsCheckersList', params)
            .then(data => {
                if (!!data.result && Array.isArray(data.result) && data.result.length > 0) {
                    return data.result;
                } else {
                    return [];
                }
            })
            .catch(e => {
                console.error('Error in: getSkillsCheckersList', e);
                return [];
            });
    }

    getTeamSkillsCheckerList(scId: number, managerId: number = null): Promise<Array<SkillsCheckerModel>> {
        const params: any = {sc_id: scId, manager_id: managerId};
        return this.requesterService.get('getTeamSkillsCheckerList', params)
            .then(data => {
                if (!!data.result && Array.isArray(data.result) && data.result.length > 0) {
                    return data.result;
                } else {
                    return [];
                }
            })
            .catch(e => {
                console.error('Error in: getTeamSkillsCheckerList', e);
                return [];
            });
    }

    getSkillsCheckerForm(scId: number, delId: number = 0): Promise<SkillsCheckerFormModel> {
        const params: any = {
            sc_id: scId,
            del_id: delId
        };
        return this.requesterService.get('getSkillsCheckerForm', params)
            .then(data => {
                if (!!data.result && !!data.result.questions
                ) {
                    return data.result;
                } else {
                    return null;
                }
            })
            .catch(e => {
                console.error('Error in: getSkillsCheckerForm', e);
                return null;
            });
    }

    saveSkillsCheckerForm(model: SkillsCheckerFormRequestModel): Promise<SkillsCheckerFormResponseModel> {
        return this.requesterService.post('saveSkillsCheckerForm', model)
            .then(data => {
                const response = new SkillsCheckerFormResponseModel();
                if (!!data.result.status) {
                    this.event.publish('skillsChecker:saveSkillsCheckerForm', data.result);
                    response.status = data.result;
                } else {
                    response.form = data.result;
                }
                return response;
            })
            .catch(e => {
                console.error('Error in: getSkillsCheckerForm', e);
                return null;
            });
    }


}
